import { CORS } from 'root/utils/cors/cors';

export default function AffiliatesPixel(cm) {
    this.cm = cm;
}

AffiliatesPixel.prototype = {
    cookieName: '_ls-affiliate',

    fire: function (callback) {
        const cookie = this.getCookie();
        if (typeof callback === 'undefined')
            callback = function () {
                /*empty*/
            };
        if (cookie === null) {
            callback();
            return;
        }
        CORS.xdr(
            '/rest/affiliates/pixel',
            'POST',
            JSON.stringify(cookie),
            function (data) {
                console.log('Success: ' + data);
                callback();
            },
            function (err) {
                console.log('Error: ' + err);
                callback();
            }
        );
    },

    getCookie: function () {
        return this.cm.getCookie(this.cookieName);
    },
};
